import Titlebar from "../layout/titlebar";
import Lang from "../../userPreferences/staticWords";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import { useEffect, useState } from "react";
import AssignmentForm from "./AssignmentForm";
import { useDispatch, useSelector } from "react-redux";
import { getAllAssignmentsAPI } from "../../API/store/actions/PresidentialAssignmenty";
import ResponseForm from "./ResponseForm";
import AssignmentCard from "./AssignmentCard";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import TextInput from "../sharedComponents/inputs/textInput";
import DateInput from "../sharedComponents/datesInputs/date";
import { FormSelect, Modal } from "react-bootstrap";
import Slide from "react-reveal/Slide";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import Button from "../sharedComponents/buttons/button";
import { getCommunityTaskForm } from "../../API/store/actions/tasks";
import CreatePresidentialDirective from "./CreatePresidentialDirective";

const PresidentialAssignmentsList = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [assignmentLoading, setAssignmentLoading] = useState(false);
  const [subjectSearch, setSubjectSearch] = useState("");
  const [memberSearch, setMemberSearch] = useState(0);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [taskFormData, setTaskFormData] = useState(null);
  const [openAssignment, setOpenAssignment] = useState(false);
  const [openCreateDirective, setOpenCreateDirective] = useState(false);

  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [openResponse, setOpenResponse] = useState(false);
  const userToken = useSelector((state) => state.login.userToken);
  const user = useSelector((state) => state.login.userData);
  const assignments = useSelector((state) => state.assignments.assignments);
  const dispatch = useDispatch();
  const [showSearch, setShowSearch] = useState(false);
  // const communityTaskForm = useSelector(
  //   (state) => state.tasks.getCommunityTaskForm,
  // );
  let membersList = [];
  const [searchDropdowns, setSearchDrobdowns] = useState({});

  if (taskFormData?.data?.members) {
    membersList = taskFormData?.data?.members.map((item) => ({
      value: item.memberId,
      label: item.memberName,
    }));
    membersList.unshift({ value: 0, label: "الكل" });
  }
  const fetchAssignments = async () => {
    setAssignmentLoading(true);

    try {
      const payload = {
        active: true,
        title: subjectSearch || undefined,
        memberId: memberSearch || undefined,
        startDate: fromDate,
        endDate: toDate,
      };

      const action = await getAllAssignmentsAPI(0, 1, 10, payload, userToken);
      dispatch(action);
    } finally {
      setAssignmentLoading(false);
    }
  };

  useEffect(() => {
    const fetchTaskForm = async () => {
      const response = await getCommunityTaskForm(0, userToken);
      if (response?.payload?.data) {
        setTaskFormData(response?.payload);
      }
    };

    if (userToken) {
      fetchTaskForm();
    }
  }, [userToken, user]);
  useEffect(() => {
    fetchAssignments();
  }, [subjectSearch, memberSearch, fromDate, toDate]);
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <Titlebar
          title={Lang.presidentialAssignments}
          customImage={"/assets/policy-green.svg"}
        />
      </div>
      <div
        style={{
          position: "relative",
          zIndex: 300,
          overflow: "visible",
        }}
      >
        <Slide left opposite collapse when={showSearch}>
          <div
            className={`d-flex flex-column col-9 col-md-12 ${styleStart(
              "p",
              4,
              "md",
            )}  justify-content-start align-items-start mt-3 `}
          >
            <div
              className="row g-3 align-items-end upperZIndex"
              style={{
                width: "700px",
                maxWidth: "100%",
                // border: "1px solid #e9ecef",
              }}
            >
              <div className="col-md-12 col-lg-6 mx-4 mx-md-0">
                <label className="form-label fw-bold">عنوان التكليف</label>
                <TextInput
                  containerStyle={"col-12"}
                  type={"text"}
                  value={subjectSearch}
                  iconName="search"
                  inputStyle={"upperZIndex"}
                  hiddenPlaceholder="ابحث بالعنوان"
                  onChange={(e) => setSubjectSearch(e.target.value)}
                />
              </div>

              <div className="col-md-12 col-lg-6 mx-4 mx-md-0">
                <label className="form-label fw-bold">الجهة المشاركة</label>
                <FormSelect
                  value={memberSearch}
                  onChange={(e) => setMemberSearch(Number(e.target.value))}
                >
                  {membersList.map((member) => (
                    <option key={member.value} value={member.value}>
                      {member.label}
                    </option>
                  ))}
                </FormSelect>
              </div>

              <div className="col-md-12 col-lg-6 mx-4 mx-md-0">
                <label className="form-label fw-bold">من </label>

                <DateInput
                  value={fromDate}
                  onChange={setFromDate}
                  isClearable
                  inputStyle={"upperZIndex"}
                  placeholder={Lang.form}
                  iconPrefix="far"
                  iconName="calendar"
                />
              </div>

              <div className="col-md-12 col-lg-6 mx-4 mx-md-0">
                <label className="form-label fw-bold">إلى </label>

                <DateInput
                  value={toDate}
                  onChange={setToDate}
                  isClearable
                  inputStyle={"upperZIndex"}
                  placeholder={Lang.form}
                  iconPrefix="far"
                  iconName="calendar"
                />
              </div>
            </div>
          </div>
        </Slide>
      </div>
      <div className="container-fluid px-2 px-md-4 m-4 m-lg-2">
        <div className="row">
          <div className="col-10 col-lg-9">
            <CardWithTitleAndIcon
              onClick={() => {
                setIsEdit(false);
                setOpenAssignment(true);
              }}
              containerStyle="d-flex justify-content-center align-items-center d-lg-none col-10 align-self-center mb-5"
              customImage={"/assets/policy-green.svg"}
              cardTitle={Lang.addPresidentialAssignment}
              height={90}
              width={230}
              imgHeight={50}
              imgWidth={60}
              containerImgHeight={50}
              containerImgWidth={60}
              boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
              borderColor={"rgba(68, 68, 68, 0.25)"}
            />
            {assignmentLoading ? (
              <div className="d-flex justify-content-center align-items-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">...جاري التحميل</span>
                </div>
              </div>
            ) : assignments?.length === 0 ? (
              <div
                className="d-flex flex-column justify-content-center align-items-center py-5"
                style={{ minHeight: 350 }}
              >
                <h5 className="mt-4 mb-2">لا توجد تكليفات رئاسية</h5>

                <p className="text-muted text-center">
                  لم يتم العثور على أي تكليفات تطابق معايير البحث.
                </p>
              </div>
            ) : (
              assignments?.map((assignment) => (
                <AssignmentCard
                  key={assignment.id}
                  assignment={assignment}
                  onAddResponse={() => {
                    setSelectedAssignment(assignment);
                    setOpenResponse(true);
                  }}
                  onEdit={() => {
                    setSelectedAssignment(assignment);
                    setOpenAssignment(true);
                    setIsEdit(true);
                  }}
                  onDelete={() => {
                    setSelectedAssignment(assignment);
                    // setIsDelete(true);
                  }}
                  onAddDirective={() => {
                    setSelectedAssignment(assignment);
                    setOpenCreateDirective(true);
                  }}
                />
              ))
            )}
          </div>
          <div
            className={`${customStyle("filterIcon")}`}
            style={{
              zIndex: 300,
              top: "150px",
              width: "80px",
              height: "80px",
            }}
            title={Lang.search}
          >
            <div
              className={`mx-2 d-flex justify-content-center align-items-center ${
                showSearch == true ? "backgroundEffect" : "bg-white"
              }`}
              style={{
                border: "1px solid rgba(199, 199, 201, 1)",
                borderRadius: "50%",
                height: 40,
                width: 40,
                marginTop: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                setShowSearch(!showSearch);
              }}
            >
              <img
                className={`${showSearch == true ? "filterEffect" : ""}`}
                src="/assets/images/filter.svg"
                width={20}
                height={20}
                alt=""
              />
            </div>
          </div>
        </div>

        <CardWithTitleAndIcon
          onClick={() => {
            setIsEdit(false);
            setOpenAssignment(true);
          }}
          containerStyle={`d-lg-flex d-none flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 position-fixed ${customStyle(
            "createTaskButton",
          )}`}
          customImage={"/assets/policy-green.svg"}
          cardTitle={Lang.addPresidentialAssignment}
          height={150}
          width={180}
          imgHeight={70}
          imgWidth={80}
          containerImgHeight={70}
          containerImgWidth={80}
          boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
          borderColor={"rgba(68, 68, 68, 0.25)"}
        />
      </div>
      {(!isEdit || selectedAssignment) && (
        <AssignmentForm
          show={openAssignment}
          setShow={setOpenAssignment}
          isEdit={isEdit}
          onSuccess={fetchAssignments}
          members={taskFormData?.data?.members || []}
        />
      )}{" "}
      {(!isEdit || selectedAssignment) && (
        <CreatePresidentialDirective
          show={openCreateDirective}
          setShow={setOpenCreateDirective}
          selectedAssignment={selectedAssignment}
          isEdit={false}
          onSuccess={fetchAssignments}
          members={taskFormData?.data?.members || []}
        />
      )}
      <ResponseForm
        show={openResponse}
        setShow={setOpenResponse}
        isEdit={isEdit}
        assignment={selectedAssignment}
        onSuccess={() => {
          fetchAssignments();
        }}
      />
    </div>
  );
};

export default PresidentialAssignmentsList;
